import React from "react";
import Header from "../../Shared/Header/Header";

const Blog = () => {
  return (
    <div>
      <Header></Header>
      <div className="p-4 container mx-auto">
        <div className="my-5">
          <h1 className="text-xl font-semibold my-2">
            Difference between authorization and authentication?
          </h1>
          <p>
            Simply put, authentication is the process of verifying who someone
            is, whereas authorization is the process of verifying what specific
            applications, files, and data a user has access to. The situation is
            like that of an airline that needs to determine which people can
            come on board. The first step is to confirm the identity of a
            passenger to make sure they are who they say they are. Once a
            passenger’s identity has been determined, the second step is
            verifying any special services the passenger has access to, whether
            it’s flying first-class or visiting the VIP lounge.
          </p>
        </div>
        <div className="my-5">
          <h1 className="text-xl font-semibold my-2">
            Why are you using firebase? What other options do you have to
            implement authentication?
          </h1>
          <p>
            The Firebase Realtime Database lets you build rich, collaborative
            applications by allowing secure access to the database directly from
            client-side code. Data is persisted locally, and even while offline,
            realtime events continue to fire, giving the end user a responsive
            experience. uthentication is used by a server when the server needs
            to know exactly who is accessing their information or site.
            Authentication is used by a client when the client needs to know
            that the server is system it claims to be. In authentication, the
            user or computer has to prove its identity to the server or client.
            Usually, authentication by a server entails the use of a user name
            and password. Other ways to authenticate can be through cards,
            retina scans, voice recognition, and fingerprints. Authentication by
            a client usually involves the server giving a certificate to the
            client in which a trusted third party such as Verisign or Thawte
            states that the server belongs to the entity (such as a bank) that
            the client expects it to.
          </p>
        </div>
        <div className="my-5">
          <h1 className="text-xl font-semibold my-2">
            What other services does firebase provide other than authentication?
          </h1>
          <p>
            Most apps need to know the identity of a user. Knowing a user's
            identity allows an app to securely save user data in the cloud and
            provide the same personalized experience across all of the user's
            devices. Firebase Authentication provides backend services,
            easy-to-use SDKs, and ready-made UI libraries to authenticate users
            to your app. It supports authentication using passwords, phone
            numbers, popular federated identity providers like Google, Facebook
            and Twitter, and more.many other option to i will use to authentication.example:</p>
            <p className="font-semibold mb-2 mt-1">Firebase auth alternatives,can i will use</p>
            <ul>
              <li>1.Parse – Open Source Backend Platform;</li>
              <li>2.Back4app – Parse Hosting Platform;</li>
              <li>3.Kinvey – Mobile Backend as a Service (mBaaS) for the Enterprise;
              </li>
              <li>4.Pubnub – Real-time APIs and Global Messaging;</li>
              <li>5.Kumulos – App Performance Management;</li>
            </ul>
        </div>
      </div>
    </div>
  );
};

export default Blog;
